import { render, staticRenderFns } from "./ResetNewPasswordView.vue?vue&type=template&id=53bddfe8&"
import script from "./ResetNewPasswordView.vue?vue&type=script&lang=js&"
export * from "./ResetNewPasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports